export const GET_HTO_SLOTS = 'hto/GET_HTO_SLOTS';
export const HTO_SLOTS_SUCCESS = 'hto/HTO_SLOTS_SUCCESS';
export const HTO_SLOTS_FAIL = 'hto/HTO_SLOTS_FAIL';
